



















































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  dispatchType = "shorturl/logs";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "时间", dataIndex: "created_time" },
    { title: "短网址", dataIndex: "urlshort" },
    { title: "长网址", dataIndex: "urllong" },
    { title: "描述", dataIndex: "description" }
  ];

  mounted() {
    this.loadData();
  }
}
